import React from 'react';
import { useAppContext } from '../shared/AppContext';
import { useAuditLogController } from './hooks/useAuditLogController';
import AuditLogView from './components/AuditLogView';

const AuditLog: React.FC = () => {
    const app = useAppContext();
    const ctrl = useAuditLogController();

    if (!app.loginUser) {
        return <div></div>;
    }

    if (!ctrl.isSuper) {
        return (
            <div className="container-fluid" style={{ padding: '20px' }}>
                <h4>Access Denied</h4>
                <p>You do not have permission to view this page.</p>
            </div>
        );
    }

    return <AuditLogView {...ctrl} />;
};

export default AuditLog;
